import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/svgs/warning-circle.svg';
import _imports_1 from '@/assets/svgs/close.svg';
import { ref, watch } from "vue";
export default {
  __name: 'subscribed-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "close"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const visible = ref(props.modelValue);
    watch(() => props.modelValue, newVal => {
      visible.value = newVal;
    });
    const closeModal = () => {
      visible.value = false;
      emit("close");
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => visible.value = $event),
        title: "",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": true,
        onClose: closeModal,
        class: "subscribed-modal"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: closeModal,
          class: "ok-button"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" OK ")])),
          _: 1,
          __: [3]
        })]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "modal-body"
        }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "warning-icon"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: "warning"
        })], -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "modal-title-container"
        }, [_createElementVNode("h3", {
          class: "modal-title"
        }, "Email Already Subscribed"), _createElementVNode("p", {
          class: "modal-message"
        }, " This account already has an active Diamond membership. Please log in to your existing account or use a different email. ")], -1)), _createElementVNode("div", {
          class: "close-button"
        }, [_createElementVNode("img", {
          src: _imports_1,
          alt: "close",
          onClick: closeModal
        })])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};